var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Folder"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE2\x86\xB3 Icon Color",
    d: "M15 13H1C0.734784 13 0.48043 12.8946 0.292893 12.7071C0.105357 12.5196 0 12.2652 0 12V1.5C0 1.10218 0.158035 0.720645 0.43934 0.43934C0.720644 0.158036 1.10218 4.77976e-07 1.5 4.77976e-07H4.062C4.40249 -0.000270424 4.73307 0.11462 5 0.326L6.965 1.891C7.05391 1.96116 7.16374 1.99954 7.277 2H14.5C14.8978 2 15.2794 2.15804 15.5607 2.43934C15.842 2.72064 16 3.10218 16 3.5V12C16 12.2652 15.8946 12.5196 15.7071 12.7071C15.5196 12.8946 15.2652 13 15 13ZM1.5 1C1.36739 1 1.24021 1.05268 1.14645 1.14645C1.05268 1.24022 1 1.36739 1 1.5V12H15V3.5C15 3.36739 14.9473 3.24022 14.8536 3.14645C14.7598 3.05268 14.6326 3 14.5 3H7.274C6.93436 2.99962 6.60484 2.88438 6.339 2.673L4.372 1.109C4.28309 1.03884 4.17326 1.00047 4.06 1H1.5Z",
    fill: "#0B1B4E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/Folder-icon.9b1b5f8c0efca51f6a95d26ac1c0f42c.svg";
export { ForwardRef as ReactComponent };